import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../atoms/icon/icon.component';

export interface StepperStep {
  label: string;
  completed?: boolean;
  icon?: string; // Optional Material Icon name
  badge?: string; // Optional badge text for step headers
  title?: string; // Optional title for step content
  description?: string[]; // Optional descriptions for step content
  hideHeader?: boolean; // If true, the step header (title/description/badge) is not rendered above the projected content
}

@Component({
  selector: 'htx-stepper-header',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './stepper-header.component.html',
  styleUrl: './stepper-header.component.scss'
})
export class StepperHeaderComponent {
  /**
   * Array of stepper steps with labels and completion status
   */
  steps = input<StepperStep[]>([]);

  /**
   * Current active step index (0-based)
   */
  currentStep = input<number>(0);

  /**
   * Check if a step is completed
   */
  isStepCompleted(index: number): boolean {
    const step = this.steps()[index];
    return step?.completed ?? false;
  }

  /**
   * Check if a step is active
   */
  isStepActive(index: number): boolean {
    return index === this.currentStep();
  }

  /**
   * Get the icon for a step (or number if no icon provided)
   */
  getStepIcon(index: number): string | null {
    return this.steps()[index]?.icon ?? null;
  }
}
